module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Light.6b4680c.ttf";